<template>
  <div v-if="loaded">
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="vx-card mb-4">
          <div class="vx-card__body card-body">
            <div
              class="
                datagrid
                vs-component vs-con-table vs-table-primary
                stripe
                table-bordered table-hover
              "
            >
              <div class="con-tablex vs-table--content">
                <div class="vs-con-tbody vs-table--tbody" id="h-table">
                  <table class="vs-table vs-table--tbody-table">
                    <tbody class="list">
                      <tr>
                        <td>{{ $t("Firstname") }}</td>
                        <td>
                          {{ details.firstName }}
                        </td>
                      </tr>
                      <tr>
                        <td>{{ $t("Lastname") }}</td>
                        <td>
                          {{ details.lastName }}
                        </td>
                      </tr>
                      <tr>
                        <td>{{ $t("PhoneNumber") }}</td>
                        <td>
                          {{ details.phoneNumber }}
                        </td>
                      </tr>
                      <tr>
                        <td>{{ $t("Email") }}</td>
                        <td>
                          {{ details.email }}
                        </td>
                      </tr>
                      <tr>
                        <td>{{ $t("ProductName") }}</td>
                        <td>
                          {{ details.productName }}
                        </td>
                      </tr>
                      <tr>
                        <td>{{ $t("ItemCode") }}</td>
                        <td>
                          {{ details.itemCode }}
                        </td>
                      </tr>
                      <tr>
                        <td>{{ $t("PlaceOfPurchase") }}</td>
                        <td>
                          {{ details.buyingPlace }}
                        </td>
                      </tr>
                      <tr>
                        <td>{{ $t("TimeOfPurchase") }}</td>
                        <td>
                          {{ details.buyingTime }}
                        </td>
                      </tr>
                      <tr>
                        <td>{{ $t("CreateOn") }}</td>
                        <td>
                          {{ details.createOn }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col w-full">
                <div class="image-box">
                  <img :src="WebSite" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
#h-table tbody tr td:nth-child(2n + 1) {
  font-weight: bold;
  width: 25%;
  background-color: #c7e0df;
}
.image-box {
  background-color: #fff;
}
.image-box img {
  margin: 20px auto;
  display: block;
  max-width: 100%;
}
</style>
<script>
import { URLS_CONSTANTS } from "../../../../config";
import { mapGetters, mapActions } from "vuex";
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";

export default {
  name: "Content_management_YaldaEvent_Details",
  data() {
    return {
      WebSite: URLS_CONSTANTS.assets + "AdvertisingCampaign/",
      loaded: false
    };
  },
  computed: {
    ...mapGetters({
      details: "advertisingCampaign/details"
    })
  },
  mounted() {
    this.load();
    setTimeout(() => {
      this.loaded = true;
    }, 500);
  },
  methods: {
    ...mapActions({
      fetchInfo: "advertisingCampaign/fetchSingle"
    }),
    load() {
      var id = this.$route.params.id;
      this.fetchInfo(id);
    }
  }
};
</script>
